import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect, useDispatch } from 'react-redux';

import ErrorContainer from 'Containers/ErrorContainer';

import consultationCategoryProp from 'PropTypes/consultationProps';

import ConsultationLoading from '../Scenes/ConsultationLoading';
import Fragrance from '../Scenes/Fragrance';

import { streamlineFragranceLabel } from 'utils/fragrances';

import { trackFragranceUpdated as trackFragranceUpdatedAction } from 'dux/tracking/actions';
import * as consultationSelectors from 'dux/consultation/selectors';
import { getUserFragrance, getUserFragranceIsSoldOut } from 'dux/user/selectors';
import { fetchFragrances } from 'dux/consultation/thunks';

const FragranceComponent = ({
  consultationCategory,
  currentFragrance,
  error,
  fragrances,
  initialValue,
  isFragranceSoldOut,
  isSaving,
  name,
  onNext,
  questionIndex,
  standalone,
  status,
  subtitle,
  title,
  trackFragranceUpdated,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (['idle', 'invalidated'].includes(status)) {
      dispatch(fetchFragrances());
    }
  }, [status, fetchFragrances]);

  const setFragrance = fragranceSelected => {
    if (currentFragrance) {
      trackFragranceUpdated({
        fragrance_updated_page_origin: 'consultation',
        from_fragrance_selection: streamlineFragranceLabel(currentFragrance),
        new_fragrance_selection: streamlineFragranceLabel(fragranceSelected),
      });
    }

    onNext(fragranceSelected);
  };

  switch (status) {
    case 'loading':
    case 'idle':
    case 'invalidated':
      return <ConsultationLoading />;
    case 'success':
      return (
        <Fragrance
          consultationCategory={consultationCategory}
          fragrances={fragrances.concat({ name: 'NONE' })}
          initialValue={initialValue}
          isSaving={isSaving}
          isSoldOut={isFragranceSoldOut}
          name={name}
          onNext={setFragrance}
          questionIndex={questionIndex}
          standalone={standalone}
          subtitle={subtitle}
          title={title}
        />
      );
    case 'error':
    default:
      return (
        <ErrorContainer
          error={error}
          retry={() => dispatch(fetchFragrances())}
          sentryMessage="Invalid state on FragranceContainer"
        />
      );
  }
};

FragranceComponent.propTypes = {
  consultationCategory: consultationCategoryProp.isRequired,
  currentFragrance: PropTypes.string,
  error: PropTypes.shape({}),
  fragrances: PropTypes.arrayOf(PropTypes.object),
  initialValue: PropTypes.string,
  isFragranceSoldOut: PropTypes.bool,
  isSaving: PropTypes.bool,
  name: PropTypes.string,
  onNext: PropTypes.func.isRequired,
  questionIndex: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  standalone: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  trackFragranceUpdated: PropTypes.func.isRequired,
};

FragranceComponent.defaultProps = {
  currentFragrance: null,
  error: null,
  fragrances: null,
  initialValue: null,
  isFragranceSoldOut: false,
  isSaving: false,
  name: 'fragrance',
  subtitle: null,
  standalone: false,
};

export default connect(
  (state, { consultationCategory, consultationSubsetCategory, questionIndex, routeParams }) => ({
    ...consultationSelectors.getConsultationQuestionForIndex(state, {
      consultationCategory,
      consultationSubsetCategory,
      questionIndex,
      routeParams,
    }),
    currentFragrance: getUserFragrance(state),
    fragrances: consultationSelectors.getFragrancesData(state),
    error: consultationSelectors.getFragrancesError(state),
    status: consultationSelectors.getFragrancesStatus(state),
    isFragranceSoldOut: getUserFragranceIsSoldOut(state),
  }),
  {
    trackFragranceUpdated: trackFragranceUpdatedAction,
  }
)(FragranceComponent);
